import { ComponentType, FlexSizeSpecValue } from '@sendbird/uikit-message-template';
export function isWrappedText(view) {
    var _a;
    return view.type === ComponentType.Text && ((_a = view.width) === null || _a === void 0 ? void 0 : _a.value) == FlexSizeSpecValue.WrapContent;
}
// Compares the size spec to the option and returns whether they are equal or not.
export const isSizeCompatibleWithOption = ({ size, option, }) => {
    if (option === 'wrap') {
        return size.type === 'flex' && size.value == FlexSizeSpecValue.WrapContent;
    }
    if (option === 'fill') {
        return size.type === 'flex' && size.value == FlexSizeSpecValue.FillParent;
    }
    return size.type === 'fixed';
};
